module.exports = __webpack_public_path__ + "img/send-message.f6612bc3.svg";